<div class="container-fluid d-flex flex-column h-100">
  <div class="row flex-grow-1">
    <div class="col">
      <app-company-vendors-grid
        [gridName]="'ClientVendors'"
        [suppliedQueryData]="SuppliedQueryData"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        (rowClick)="actionEvent({ action: 'view', rowData: $event.data })"
      ></app-company-vendors-grid>
    </div>
  </div>
</div>
